import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

interface PropsType {
    className?: string;
    onClick?: () => void;
    dataTest?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const SaveIcon = observer(
    ({ className, dataTest, onClick }: PropsType): React.ReactElement => (
        <SvgElement
            className={className}
            width={10}
            height={10}
            onClick={onClick}
            fill='#fff'
            viewBox='0 0 10 10'
            data-test={dataTest}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1.597 10H8.403C9.285 10 10 9.285 10 8.403V3.056a.625.625 0 0 0-.183-.442L7.387.184A.625.625 0 0 0 6.943 0H1.597C.715 0 0 .715 0 1.597v6.806C0 9.285.715 10 1.597 10ZM3.75 1.25h2.936L8.75 3.314v5.089a.347.347 0 0 1-.347.347H7.5V5.625A.625.625 0 0 0 6.875 5h-3.75a.625.625 0 0 0-.625.625V8.75h-.903a.347.347 0 0 1-.347-.347V1.597c0-.192.155-.347.347-.347H2.5v1.875c0 .345.28.625.625.625h3.75a.625.625 0 1 0 0-1.25H3.75V1.25Zm2.5 7.5h-2.5v-2.5h2.5v2.5Z'
                fill='#fill'
            />
        </SvgElement>
    )
);
